import { Pipe, PipeTransform } from '@angular/core';


@Pipe( { name: 'localeFilter' } )
export class LocaleFilterPipe<T> implements PipeTransform {
    transform( list: any[], locale: string ): T {

        if ( list != null ) {
            for ( let i of list ) {
                if ( i.locale == locale ) {
                    return i;
                }
            }
        }

        return null;
    }
}